<template lang="pug">
#decree
  custom-header
  section.container.custom_container_md.custom_container_news_sm
    .row.i_mt_14.i_mt_md_10
      .col-12.text-center.text-md-left
        h2.title 政令宣導
    news-item(
      v-for="(news, index) in currentDecreeList",
      :key="index",
      :news="news",
      :direction="index % 2",
      :type="'decree'"
    )
    .row.i_mt_8
      .col-12.text.center.justify-content-center
        b-pagination(
          v-model="currentPage",
          :total-rows="totalRows",
          :per-page="perPage",
          first-number,
          last-number
        )
  custom-footer
</template>

<script>
import NewsItem from "@/components/about_us/news/NewsItem";
import CustomFooter from "@/components/common/Footer";
import CustomHeader from "@/components/common/Header";
import { getDecree } from "@/json/menu";

export default {
  name: "Decree",
  components: {
    "news-item": NewsItem,
    "custom-footer": CustomFooter,
    "custom-header": CustomHeader,
  },
  data() {
    return {
      decree: {},
      currentDecreeList: [],

      totalRows: 0,
      perPage: 5,
      currentPage: 1,
    };
  },
  watch: {
    currentPage() {
      this.getCurrentList();
    },
  },
  created() {
    this.getDecree();
  },
  methods: {
    getDecree() {
      getDecree().then((response) => {
        this.decree = response.data;
        this.totalRows = response.data.DecreeList.length;
        this.getCurrentList();
      });
    },
    getCurrentList() {
      this.currentDecreeList = [];
      let number = this.perPage * this.currentPage;
      this.currentDecreeList = this.decree.DecreeList.slice(
        number - this.perPage,
        number
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/pagination";
@import "@/assets/style/about_us/news";

h3 {
  font-size: 24px;
  padding-bottom: 10px;
  @include font(24px, $color_blue_ci, 300);
}

@media (max-width: 991px) {
  h3 {
    font-size: 20px;
  }
}

@media (max-width: 767px) {
  h3 {
    font-size: 24px;
  }
}
</style>
